import jobServices from 'ApiService/Placement/jobServices';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import Attachments from './Attachments';

const AllStudents = ({
  classData,
  setClassData,
  selectedStudent: parentSelectedStudent,
  setSelectedStudent: setParentSelectedStudent,
}) => {
  const [studentDetails, setStudentDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('');
  const [jobPriorityFilter, setJobPriorityFilter] = useState('all');

  useEffect(() => {
    async function fetchStudents() {
      setLoading(true);
      try {
        const requestData = {};
        if (classData.courseId) {
          requestData.courseId = classData.courseId;
        }
        if (classData.batchId) {
          requestData.batchId = classData.batchId;
        }
        if (selectedBranch) {
          requestData.branchId = selectedBranch;
        }
        const response = await jobServices.getPlacementReadyStudent(
          requestData.courseId,
          requestData.batchId,
          requestData.branchId
        );

        if (response.data.success) {
          const data = response.data.data;
          setStudentDetails(data || []);
          setLoading(false);
          if (response.data.data.length === 0) {
            toast.error('No students found ');
          }
        } else {
          setStudentDetails([]);
          toast.error(response?.data?.message);
        }
      } catch (error) {
        setLoading(false);
        setStudentDetails([]);
        toast.error(error?.response?.data?.message);
      }
    }
    fetchStudents();
  }, [classData.courseId, classData.batchId, selectedBranch]);

  useEffect(() => {
    let result = [...studentDetails];

    if (searchTerm) {
      result = result.filter(
        (student) =>
          student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.contactNumber.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filter !== 'all') {
      result = result.filter(
        (student) => student.gender.toLowerCase() === filter
      );
    }

    if (jobPriorityFilter !== 'all') {
      result = result.filter(
        (student) =>
          student.placementPriority.toLowerCase() === jobPriorityFilter
      );
    }

    setFilteredData(result);
  }, [studentDetails, filter, jobPriorityFilter, searchTerm]);

  function resetFilters() {
    setFilteredData(studentDetails);
    setClassData({
      ...classData,
      courseId: '',
      batchId: '',
    });
    setParentSelectedStudent(null);
    setFilteredData([]);
    setFilter('all');
    setSearchTerm('');
    setSelectedBranch('');
    setJobPriorityFilter('all');
    setStudentDetails([]);
  }

  const handleAttendanceClick = (student) => {
    setParentSelectedStudent(student);
  };

  return (
    <div className="w-full p-4 sm:overflow-auto">
      {loading ? (
        <div className="flex h-40 w-full items-center justify-center">
          <ThreeDots color="#5431ed" className="mt-100" />
        </div>
      ) : (
        <>
          {parentSelectedStudent ? (
            <Attachments selectedStudent={parentSelectedStudent} />
          ) : (
            <div extra="w-full sm:overflow-auto p-4">
              <div className="mt-2 flex w-full flex-col items-center gap-4 sm:flex-row">
                <div className="w-full rounded-xl border border-gray-200 bg-lightPrimary py-2.5 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                  <input
                    type="text"
                    placeholder="Search."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-800 dark:text-white"
                  />
                </div>

                <div className="w-full sm:w-[200px]">
                  <button
                    onClick={resetFilters}
                    className="w-40 rounded-xl bg-brand-500 py-2.5 pl-2 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    Reset
                  </button>
                </div>
              </div>

              <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
                {filteredData.length === 0 ? (
                  <div className="mt-4 text-center text-gray-600 dark:text-white">
                    <p className="mt-0 text-center ">
                      <Nodatafound title="No Student data found" />
                    </p>
                  </div>
                ) : (
                  <table variant="simple" color="gray-500" mb="24px">
                    <thead>
                      <tr>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Sr No
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Name
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Gender
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Email
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Contact Number
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Address
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Priority
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Location preference
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Preferred Salary
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          View
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((student, index) => (
                        <tr key={student._id} className="cursor-pointer">
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {index + 1}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.name}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.gender}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.email}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.contactNumber}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.address.street}, {student.address.city},{' '}
                            {student.address.state},{' '}
                            {student.address.postalCode},{' '}
                            {student.address.country}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.placementPriority}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.jobLocationPreference.map((item) => (
                              <ul key={item}>
                                <li>{item}</li>
                              </ul>
                            ))}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm">
                            <span
                              className={`rounded-full px-2 py-1 text-xs font-semibold ${
                                student.preferredSalary === 'More than 5 LPA'
                                  ? 'bg-green-100 text-green-700'
                                  : student.preferredSalary === 'Below 5 LPA'
                                  ? 'bg-blue-100 text-blue-700'
                                  : student.preferredSalary === 'Below 4 LPA'
                                  ? 'bg-yellow-100 text-yellow-700'
                                  : student.preferredSalary === 'Below 3 LPA'
                                  ? 'bg-orange-100 text-orange-700'
                                  : 'bg-gray-100 text-gray-700'
                              }`}
                            >
                              {student.preferredSalary || 'Any Salary'}
                            </span>
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white ">
                            <span
                              onClick={() => handleAttendanceClick(student)}
                              className="underline dark:text-white"
                            >
                              View Attachment's
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AllStudents;
